/**
 * dehydrate - dehydrate this slice of state into a serializable form
 */
export default function dehydrate(state) {
  return state;
}



// WEBPACK FOOTER //
// ./src/state/teachers/dehydrate.js